module.exports = __webpack_public_path__ + "fonts/Courier-Bold.b2990598.woff2";